/**
 * Je to mobil?
 *
 * @return {boolean}
 */
export const isMobile = () => window.innerWidth <= 1200;
